import type { GetBomTableParams, GetBomTableQueryKeyType } from './types';

export const getBomTableQueryKey = (
  params: GetBomTableParams,
): GetBomTableQueryKeyType => {
  return ['bomTable', params.id, params.bomType, params.search, params.grouped];
};
